// HighValueSettings.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/highValueSettings.css';
import { BadgeEuro } from 'lucide-react';

function HighValueSettings() {
    const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
    const [highValueThreshold, setHighValueThreshold] = useState(null);
    const [isEnabled, setIsEnabled] = useState(false);

    useEffect(() => {
        axios.get(`${baseUrl}/api/high-value-threshold/`)
            .then(response => {
                setHighValueThreshold(parseFloat(response.data.high_value_threshold).toFixed(2));
            })
            .catch(error => {
                toast.error('Error fetching high-value threshold');
                console.error('Error fetching high-value threshold:', error);
            });
    }, [baseUrl]);

    const updateThreshold = () => {
        const formattedThreshold = parseFloat(highValueThreshold).toFixed(2);

        axios.post(`${baseUrl}/api/high-value-threshold/`, { high_value_threshold: formattedThreshold })
            .then(response => {
                toast.success('High-value threshold updated successfully!');
                setIsEnabled(!isEnabled)
            })
            .catch(error => {
                toast.error('Error updating high-value threshold');
                console.error('Error updating high-value threshold:', error);
            });
    };

    const handleToggle = () => {
        setIsEnabled(!isEnabled);
    };

    return (
        <section className="high-value-card modern-panel">
            <div className="high-value-card-header">
                <div className="high-value-title">
                    <span className="high-value-icon"><BadgeEuro size={21} /></span>
                    <h2>High-Value Threshold</h2>
                </div>
                <label className="high-value-switch">
                    <input type="checkbox" checked={isEnabled} onChange={handleToggle} />
                    <span className="high-value-slider high-value-round"></span>
                    <span className="visually-hidden">Enable threshold editing</span>
                </label>
            </div>
            <div className="high-value-card-content">
                {highValueThreshold !== null && (
                    <>
                        <label className="high-value-field">
                            <span>Threshold (€)</span>
                            <input
                                type="number"
                                value={highValueThreshold}
                                onChange={(e) => setHighValueThreshold(e.target.value)}
                                disabled={!isEnabled}
                                className="high-value-input-field"
                            />
                        </label>
                        <button onClick={updateThreshold} disabled={!isEnabled} className="high-value-update-button">
                            Update
                        </button>
                    </>
                )}
                {highValueThreshold === null && (
                    <span className="modern-dot-loader" aria-label="Loading threshold"><span></span><span></span><span></span></span>
                )}
            </div>
            <ToastContainer />
        </section>
    );
}

export default HighValueSettings;
